export default {
  SET_PRODUCT_DETAILS: "SET_PRODUCT_DETAILS",
  SET_PROUDCT_LIKE: "SET_PROUDCT_LIKE",
  SET_PRODUCT_EXTRA_INFO: "SET_PRODUCT_EXTRA_INFO",
};
